var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublicacoesOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.26,
    height: 22.26,
    viewBox: "0 0 22.26 22.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.086,2.782V20.868H6.478a2.087,2.087,0,1,1,0-4.174H19.695V0H5.782A2.791,2.791,0,0,0,3,2.782V19.477A2.791,2.791,0,0,0,5.782,22.26H22.477V2.782Z",
    transform: "translate(-1.609)",
    fill: "#c2c4d4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7,39h0a.7.7,0,0,0,0,1.391H22.912V39Z",
    transform: "translate(-4.826 -20.914)",
    fill: "#c2c4d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H22.26V22.26H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicacoesOff);
export default __webpack_public_path__ + "static/media/Publicacoes-Off.31e065249c47b61751811786fce4bac2.svg";
export { ForwardRef as ReactComponent };